



















































import {
  defineComponent,
  ref,
  Ref,
} from '@vue/composition-api';

import {
  getPurchaseOrderItemsUnion,
} from '@/api';
import purchaseOrderItemTableOption from '@/table/PurchaseOrder/purchase-order-item';
import purchaseOrderItemWithoutEditableTableOption from '@/table/PurchaseOrder/purchase-order-item-without-edit-controls';

const PanelWithPurchaseOrderItemTable = defineComponent({
  props: {
    variables: {},
    refetch: {},
    editable: { default: false },
  },
  setup() {
    // Use with select box
    const initiatePurchaseOrderId = ref(-1);
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string, poId: number) {
      if (initiatePurchaseOrderId.value === -1 || initiatePurchaseOrderId.value === poId) {
        initiatePurchaseOrderId.value = poId;

        const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
        if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
        else selectedItemId.value.push(parseInt(id as string, 10));

        if (selectedItemId.value.length === 0) initiatePurchaseOrderId.value = -1;
      }
    }
    function clearSelect() {
      selectedItemId.value = [];
      initiatePurchaseOrderId.value = -1;
    }

    return {
      getPurchaseOrderItemsUnion,
      purchaseOrderItemTableOption,
      purchaseOrderItemWithoutEditableTableOption,

      initiatePurchaseOrderId,
      selectItem,
      clearSelect,
      selectedItemId,
    };
  },
});

export default PanelWithPurchaseOrderItemTable;
